const mapping = {
  makes: {
    'rolls-royce': 'rolls-royce',
    'mercedes-benz': 'mercedes-benz',
    ds: 'ds automobiles',
    'mg-motor-uk': 'mg'
  },
  models: {
    'e-tron': 'e-tron',
    'e-tron-gt': 'e-tron',
    'e-tron-s': 'e-tron-s',
    'q4-e-tron': 'q4-e-tron',
    'rs-e-tron-gt': 'rs-e-tron-gt',
    'r-type': 'r-type',
    'c-crosser': 'c-crosser',
    'c-zero': 'c-zero',
    'b-max': 'b-max',
    'c-max': 'c-max',
    'focus-c-max': 'focus-c-max',
    'grand-c-max': 'grand-c-max',
    's-max': 's-max',
    'cr-v': 'cr-v',
    'cr-x': 'cr-x',
    'cr-z': 'cr-z',
    'fr-v': 'fr-v',
    'hr-v': 'hr-v',
    'd-max': 'd-max',
    'e-pace': 'e-pace',
    'e-type': 'e-type',
    'f-pace': 'f-pace',
    'f-type': 'f-type',
    'i-pace': 'i-pace',
    's-type': 's-type',
    'x-type': 'x-type',
    'xfr-s': 'xfr-s',
    'xjr-s': 'xjr-s',
    'xkr-s': 'xkr-s',
    'cx-3': 'cx-3',
    'cx-30': 'cx-30',
    'cx-5': 'cx-5',
    'cx-7': 'cx-7',
    'cx-80': 'cx-80',
    'mx-3': 'mx-3',
    'mx-30': 'mx-30',
    'mx-5': 'mx-5',
    'mx-5-rf': 'mx-5-rf',
    'rx-7': 'rx-7',
    'rx-8': 'rx-8',
    'zt-t': 'zt-t',
    'i-miev': 'i-miev',
    'gt-r': 'gt-r',
    'x-trail': 'x-trail',
    'gen-2': 'gen-2',
    '9-3': '9-3',
    '9-3x': '9-3x',
    '9-5': '9-5',
    'sx4-s-cross': 'sx4-s-cross',
    'x-90': 'x-90',
    'c-hr': 'c-hr',
    't-cross': 't-cross',
    't-roc': 't-roc',
    'q8-e-tron': 'q8-e-tron',
    'sq8-e-tron': 'sq8-e-tron',
    'one-77': 'one-77',
    'e-berlingo': 'e-berlingo',
    'e-c4': 'e-c4',
    'e-c4-x': 'e-c4-x',
    'e-spacetourer': 'e-spacetourer',
    'zr-v': 'zr-v',
    'e-2008': 'e-2008',
    'e-208': 'e-208',
    'e-308': 'e-308',
    'e-rifter': 'e-rifter',
    'e-traveller': 'e-traveller',
    'megane-e-tech': 'megane e-tech',
    '5-e-tech-electric': '5 e-tech electric',
    'korando-e-motion': 'korando-e-motion',
    'combo-e-life': 'combo-e-life',
    'corsa-e': 'corsa-e',
    'mokka-e': 'mokka-e',
    'vivaro-e-life': 'vivaro-e-life',
    'e-up!': 'e-up!',
    'e-golf': 'e-golf',
    '1': '#1',
    '5': '5',
    'e-nv200': 'e-nv200',
    a6: 'a6 avant',
    'puma-gen-e': 'puma gen-e',
    'e-c3-aircross': 'e-c3 aircross',
    'rs-7': 'rs7',
    'rs-q8': 'rsq8',
    rs4: 'rs4 avant',
    rs6: 'rs6 avant',
    'continental-gt': 'continental',
    'continental-gtc': 'continental',
    corvette: 'corvette stingray',
    'space-tourer': 'spacetourer',
    's-max-vignale': 's-max',
    '3': '#3',
    'polestar-3': 'polestar 3',
    'ora-funky-cat': 'funky cat',
    'e-ny1': 'e:ny1',
    'ioniq-5-n': 'ioniq 5',
    'pro-ceed': 'proceed',
    defender: 'defender 90',
    '2': 'polestar 2',
    '2-hybrid': 'mazda2',
    'cx-60': 'cs-60',
    '720': '720s',
    '750': '750s',
    hs: 'mg hs',
    zs: 'mg zs',
    '308': '308 sw',
    traveller: 'e-traveller',
    '4': 'polestar 4',
    '718': '718 boxster',
    boxster: '718 boxster',
    cayman: '718 cayman',
    'macan-electric-estate': 'macan',
    'scenic-e-tech': 'scenic e-tech',
    'fortwo-cabrio': 'fortwo',
    'fortwo-coupe': 'fortwo',
    'hashtag-1': '#1',
    'hashtag-3': '#3',
    's-cross': 'sx4',
    'gr-yaris': 'yaris',
    'proace-city-verso': 'proace',
    'id-buzz': 'id. buzz',
    id3: 'id.3',
    id4: 'id.4',
    id5: 'id.5',
    id7: 'id.7',
    'a6-e-tron-avant': 'a6 e-tron avant',
    'a6-e-tron-sportback': 'a6 e-tron sportback',
    'q6-e-tron': 'q6 e-tron',
    's6-e-tron-avant': 's6 e-tron avant',
    's6-e-tron-sportback': 's6 e-tron sportback',
    's-e-tron-gt': 's e-tron gt',
    'sq6-e-tron': 'sq6 e-tron',
    'e-3008': 'e-3008',
    'e-5008': 'e-5008',
    'e-308-sw': 'e-308 sw',
    '4-e-tech-electric': '4 e-tech electric'
  }
};

export const transformMake = (urlMake: string): string => {
  const make = urlMake.toLocaleLowerCase();
  if (mapping.makes[make]) {
    return mapping.makes[make];
  } else {
    return make.replace(/-/g, ' ');
  }
};

export const transformModel = (urlModel: string): string => {
  const model = urlModel.toLocaleLowerCase().replace(/ /g, '-');
  if (mapping.models[model]) {
    return mapping.models[model];
  } else {
    return model.replace(/-/g, ' ');
  }
};



// WEBPACK FOOTER //
// ./src/Common/buildQuery/mapping.js